/* export default {
    namespaced: true,
    state: {
        auidoStateArr: [], // 控制音频状态的数组
        excludeState: 0, // 互斥状态,默认为0,代表互斥,1代表不互斥
    },
    mutations: {
        setAuidoStateArr(state,audioObj){ // 增加音频状态数据事件
            for(let i = 0; i < state.auidoStateArr.length; i++){
                if(state.auidoStateArr[i].id == audioObj.id){
                    return;
                }
            }
            state.auidoStateArr.push(audioObj);
        },
        setAudioData(state,option){
            for(let i = 0; i < state.auidoStateArr.length; i++){
                if(state.auidoStateArr[i].id == option.id){
                    state.auidoStateArr[i].flag = option.flag;
                }
            }
        }
    },
} */
export default {
    // 这是关于音频管理的数据
    namespaced: true, // 当 namespaced 设置为true之后引入在index中的时候不会与其他相同名称的数据或方法发生冲突
    state: {
        auidoStateArr: [true,false,false], // 控制音频状态的数组
        auidoStateArrCopy: [], // 暂存音频状态
        excludeState: 0, // 互斥状态,默认为0,代表互斥,1代表不互斥
        audioExcludeState: 1, // 音频互斥状态，1代表暂停播放之前正在播放的音频 0代表不播放之前的音频
        methodArr: [], // 回调数组
        musicOption: { // 背景音乐配置项
            loop: true,
            autoplay: true,
            src: "https://hmltec.oss-cn-beijing.aliyuncs.com/jingshan/staticState/audio/backgroundmusic.mp3"
        },
        soundOption: { // 解说配置项
            loop: false,
            autoplay: true,
            src: "",
        },
    },
    mutations: {
        setAudioArr(state,options){
            // 互斥和不互斥
                // 相同点：视屏播放的时候停止所有音频，视屏暂停时恢复之前的播放
                // 不同点：
                    // 互斥
                        // 播放音频的时候停止其他播放
                        // 停止播放的时候
                            // 恢复之前的播放
                            // 不恢复之前的播放
                    // 不互斥
                        // 播放或暂停当前音频即可
             // console.log(options.index,options.flag);
            if(options.index == -1){ // 当前是视频在改变状态
                if(options.flag){ // 播放
                    state.auidoStateArrCopy = []; // 清空复制状态的数组，防止之前有数据
                    state.auidoStateArrCopy.push(...state.auidoStateArr); // 将当前未改变数组的数据存储在 auidoStateArrCopy 中
                    // 循环状态数组，将所有为true的数据置为false
                    for(let i = 0; i < state.auidoStateArr.length; i++){
                        if(state.auidoStateArr[i]){
                            state.auidoStateArr.splice(i,1,false);
                        }
                    }
                }else{ // 暂停
                    // 循环状态数组，判断当前状态和保存的状态是否相同，不同重置为之前的状态
                    for(let i = 0; i < state.auidoStateArr.length; i++){
                        if(state.auidoStateArr[i] != state.auidoStateArrCopy[i]){
                            state.auidoStateArr.splice(i,1,state.auidoStateArrCopy[i]);
                        }
                    }
                }
            }else{ // 当前是音频在改变状态
                 // console.log("音频改变状态");
                if(options.flag){ // 播放
                     // console.log("播放状态");
                    // 判断回调数组中是否有数据，有的话循环执行每一项数据
                    if(state.methodArr.length > 0){
                        state.methodArr.forEach(item => {
                            item.fun();
                        });
                    }
                    if(!state.excludeState){ // 互斥
                         // console.log("互斥状态");
                        // 是否播放之前的音频
                        if(state.audioExcludeState){
                             // console.log("暂停之后恢复之前播放");
                            state.auidoStateArrCopy = []; // 清空复制状态的数组，防止之前有数据
                            // 将当前未改变数组的数据存储在 auidoStateArrCopy 中
                            state.auidoStateArrCopy.push(...state.auidoStateArr);
                            for(let i = 0; i < state.auidoStateArr.length; i++){
                                if(state.auidoStateArr[i]){
                                    state.auidoStateArr.splice(i,1,false);
                                }
                            }
                        }else{
                             // console.log("暂停之后不恢复之前播放");
                            for(let i = 0; i < state.auidoStateArr.length; i++){
                                if(state.auidoStateArr[i]){
                                    state.auidoStateArr.splice(i,1,false);
                                }
                            }
                        }
                        state.auidoStateArr.splice(options.index,1,true);
                    }else{ // 不互斥
                         // console.log("不互斥状态");
                        state.auidoStateArr.splice(options.index,1,true);
                    }
                }else{ // 暂停
                     // console.log("暂停")
                    if(!state.excludeState){ // 互斥
                         // console.log("互斥")
                        if(state.audioExcludeState){
                             // console.log("音频互斥")
                            // 循环状态数组，判断当前状态和保存的状态是否相同，不同重置为之前的状态
                            for(let i = 0; i < state.auidoStateArr.length; i++){
                                if(state.auidoStateArr[i] != state.auidoStateArrCopy[i]){
                                     // console.log(1,state.auidoStateArr);
                                    state.auidoStateArr.splice(i,1,state.auidoStateArrCopy[i]);
                                     // console.log(2,state.auidoStateArr);
                                    break;
                                }
                            }
                        }
                    }
                     // console.log(3,state.auidoStateArr);
                    state.auidoStateArr.splice(options.index,1,false);
                     // console.log(4,state.auidoStateArr);
                }
            }
             // console.log(5,state.auidoStateArr);
        },
        addFun(state,methodObj){
            let arrLenth = state.methodArr.length;
            for(let i = 0; i < arrLenth; i++){
                let currentObj = state.methodArr[i];
                if(currentObj.name == methodObj.name){
                    return;
                }
            }
            let obj = {
                fun: methodObj.fun,
                name: methodObj.name
            };
            state.methodArr.push(obj);
             // console.log(state.methodArr);
        },
        removeFun(state,name){
             // console.log(name);
            let arrLenth = state.methodArr.length;
            for(let i = 0; i < arrLenth; i++){
                let currentObj = state.methodArr[i];
                if(currentObj.name == name){
                    state.methodArr.splice(i,1);
                }
            }
             // console.log(state.methodArr);
        },
        setSoundSrc(state,src){
            state.soundOption.src = src;
        },
    },
    actions: {

    }
}